import { render, staticRenderFns } from "./TemplateDashboardList.vue?vue&type=template&id=57b9b566"
import script from "./TemplateDashboardList.vue?vue&type=script&lang=js"
export * from "./TemplateDashboardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports